import { render, staticRenderFns } from "./RelatedPost.vue?vue&type=template&id=21a7c86c&"
import script from "./RelatedPost.vue?vue&type=script&lang=js&"
export * from "./RelatedPost.vue?vue&type=script&lang=js&"
import style0 from "./RelatedPost.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports